import { AgentContractDto } from 'types/dto/contracts-service';

export const formatContracts = (data: AgentContractDto[]) => {
  return data.map(item => {
    return { ...item, contractDate: item.contractDate?.slice(0, -9) };
  });
};
